import React, { useState, useEffect, useContext, useRef } from "react";
import axios from "axios";
import styled from "styled-components";
import { NotificationManager } from "react-notifications";
import Button from "@mui/material/Button";
import { makeStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import UserService from "services/UserService";
import { updateAccountMeters, getAccountContracts, getAccountDsos, getAPIAuthorizationList } from "services/ConfigServices";
import { compte } from "variables/patrimoine.js";
import {typebyenergy, utilitytypebyenergy} from "variables/lists/authorization";
import CustomSelect from "components/Input/CustomSelect.js";
import CustomSwitch from "components/Input/CustomSwitch.js";
import AdvancedSearchContext from "context/AdvancedSearchContext";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "64.5ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "15px",
    marginRight: "auto",
    marginLeft: "0.5rem",
    width: "64.5ch",
  },
}));

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;


function EditMetersDialog(props) {
  const { closeModal, refetch, meters, energy, parameters } = props;

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup } = appContext;

  const [authorizationData, setAuthorizationData] = useState([]);
  const [utilityauthorizationData, setUtilityauthorizationData] = useState([]);
  const [utilitiesData, setUtilitiesData] = useState([]);
  const [dsoData, setDsoData] = useState([]);

  const [status, setStatus] = useState("");
  const [metersDso, setMetersDso] = useState("");
  const [associatedcontractid, setAssociatedcontractid] = useState("");
  const [authorizationid, setAuthorizationid] = useState();
  const [utilityauthorizationid, setUtilityauthorizationid] = useState();
  const [monthlyconsumption, setMonthlyconsumption] = useState(false);
  const [dailyconsumption, setDailyconsumption] = useState(false);
  const [loadcurve, setloadcurve] = useState(false);
  const [contractualdata, setContractualdata] = useState(false);
  const [utilitydata, setUtilitydata] = useState(false);

  const [statusupdate, setStatusupdate] = useState(false);
  const [metersDsoupdate, setMetersDsoupdate] = useState(false);
  const [associatedcontractidupdate, setAssociatedcontractidupdate] = useState(false);
  const [authorizationidupdate, setAuthorizationidupdate] = useState(false);
  const [utilityauthorizationidupdate, setUtilityauthorizationidupdate] = useState(false);
  const [dataupdate, setDataupdate] = useState(false);
  const [utilitydataupdate, setUtilitydataupdate] = useState(false);

  const handleStatusChange = (e) => {
    setStatus(e.target.value);
  };
  const handleDsoChange = (e) => {
    setMetersDso(e.target.value);
  };
  const handleAssociatedcontractidChange = (e) => {
    setAssociatedcontractid(e.target.value);
  };
  const handleAuthorizationidChange = (e) => {
    setAuthorizationid(e.target.value);
  };
  const handleUtilityauthorizationidChange = (e) => {
    setUtilityauthorizationid(e.target.value);
  };
  const handleMonthlyconsumptionChange = (e) => {
    setMonthlyconsumption(!monthlyconsumption);
  };
  const handleDailyconsumptionChange = (e) => {
    setDailyconsumption(!dailyconsumption);
  };
  const handleLoadcurveChange = (e) => {
    setloadcurve(!loadcurve);
  };
  const handleContractualdataChange = (e) => {
    setContractualdata(!contractualdata);
  };
  const handleUtilitydataChange = (e) => {
    setUtilitydata(!utilitydata);
  };

  const handleStatusupdateChange = (event) => {
    setStatus("");
    setStatusupdate(!statusupdate);
  };
  const handleMetersDsoupdateChange = (event) => {
    setMetersDso("");
    setMetersDsoupdate(!metersDsoupdate);
  };
  const handleAssociatedcontractidupdateChange = (event) => {
    setAssociatedcontractid("");
    setAssociatedcontractidupdate(!associatedcontractidupdate);
  };
  const handleAuthorizationidupdateChange = (event) => {
    setAuthorizationid();
    setAuthorizationidupdate(!authorizationidupdate);
  };
  const handleUtilityauthorizationidupdateChange = (event) => {
    setUtilityauthorizationid();
    setUtilityauthorizationidupdate(!utilityauthorizationidupdate);
  };
  const handleDataupdateChange = (event) => {
    setMonthlyconsumption(false);
    setDailyconsumption(false);
    setloadcurve(false);
    setContractualdata(false);
    setDataupdate(!dataupdate);
  };
  const handleUtilitydataupdateChange = (event) => {
    setUtilitydata(false);
    setUtilitydataupdate(!utilitydataupdate);
  };

  const [buttonDisabled, setButtonDisabled] = useState(true);
  useEffect(() => {
    let disabled = false;
    if (!statusupdate && !metersDsoupdate && !associatedcontractidupdate
      && !authorizationidupdate && !dataupdate && !utilitydataupdate && !utilityauthorizationidupdate)
      disabled = true;
    else {
      if (statusupdate && !status)
        disabled = true;
      if (metersDsoupdate && !metersDso)
        disabled = true;
      if (associatedcontractidupdate && !associatedcontractid)
        disabled = true;
      if (authorizationidupdate && !authorizationid)
        disabled = true;
      if (utilityauthorizationidupdate && !utilityauthorizationid)
        disabled = true;
    }
    setButtonDisabled(disabled);
  }, [status,
    metersDso,
    associatedcontractid,
    authorizationid,
    statusupdate,
    metersDsoupdate,
    associatedcontractidupdate,
    authorizationidupdate,
    dataupdate,
    utilityauthorizationid,
    utilityauthorizationidupdate,
    utilitydataupdate
  ]);

  const handleSubmit = () => {
    updateMeters();
  };

  const updateMeters = async (event) => {
    const update = {};
    const updated = meters.map((meter) => {
      let updatemeter = meter;
      if (statusupdate)
        updatemeter.details.status = status;
      if (metersDsoupdate)
        updatemeter.details.dso = metersDso;
      if (associatedcontractidupdate)
        updatemeter.details.associatedcontractid = associatedcontractid;
      if (authorizationidupdate)
        updatemeter.details.authorizationid = authorizationid;
      if (utilityauthorizationidupdate)
        updatemeter.details.utilityauthorizationid = utilityauthorizationid;
      if (dataupdate) {
        updatemeter.details.monthlyconsumption = monthlyconsumption;
        updatemeter.details.dailyconsumption = dailyconsumption;
        updatemeter.details.loadcurve = loadcurve;
        updatemeter.details.contractualdata = contractualdata;
      }
      if (utilitydataupdate) {
        updatemeter.details.utilitydata = utilitydata;
      }
      return (
        updatemeter
      );
    });

    await axios
      .put(
        updateAccountMeters("update", chartIdGroup, energy),
        {
          meters: updated,
        },
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          setNotification("success", "Compteurs modifiés");
        } else setNotification("error", "Une erreur est survenue");
        closeModal();
        refetch();
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };
  const classes = useStyles();

  const statusData = [
    { name: "Actif", id: "on" },
    { name: "Résilié", id: "off" },
  ];

  useEffect(() => {
    axios
      .get(
        getAccountDsos(chartIdGroup, energy),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        let tmpDsoData = res.data.dsos?.map((data) => {
          return (
            { name: data.details.name, id: data.uuid }
          );
        });
        setDsoData(tmpDsoData);
      });
  }, []);

  useEffect(() => {
    axios
      .get(
        getAccountContracts(chartIdGroup, energy),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        let tmpUtilitiesData = res.data.contracts?.map((data) => {
          return (
            { name: data.details.contractnumber + " (" + data.details.name + ")", id: data.uuid }
          );
        });
        setUtilitiesData(tmpUtilitiesData);
      });
  }, []);

  useEffect(() => {
    axios
      .get(
        getAPIAuthorizationList(chartIdGroup),
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        }
      )
      .then((res) => {
        let tmpAuthorizationData = res.data.authorizations?.filter((data) => data.energy === energy && typebyenergy[energy].includes(data.type)).map((data) => {
          return (
            { name: data.legalname + " (" + data.dateend + ")", id: data.id }
          );
        });
        setAuthorizationData(
          tmpAuthorizationData || []
        );
        let tmpUtilityauthorizationData = res.data.authorizations?.filter((data) => data.energy === energy && utilitytypebyenergy[energy].includes(data.type)).map((data) => {
          return (
            { name: data.legalname + " (" + data.dateend + ")", id: data.id }
          );
        });
        setUtilityauthorizationData(
          tmpUtilityauthorizationData || []
        );
      });
  }, []);

  return (
    <>
      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer>
              <GridItem xs={2} sm={2} md={2} lg={2}>
                <div>
                  <CustomSwitch
                    inputTitle={''}
                    checkedState={statusupdate}
                    handleSwitchChange={handleStatusupdateChange}
                  />
                </div>
              </GridItem>
              <GridItem xs={10} sm={10} md={10} lg={10}>
                <div>
                  <CustomSelect
                    inputTitle={compte.energy[energy][parameters].status}
                    selectValue={status}
                    handleSelectValueChange={handleStatusChange}
                    data={statusData}
                    disabled={!statusupdate}
                  />
                </div>
              </GridItem>
            </GridContainer>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer>
              <GridItem xs={2} sm={2} md={2} lg={2}>
                <div>
                  <CustomSwitch
                    inputTitle={''}
                    checkedState={metersDsoupdate}
                    handleSwitchChange={handleMetersDsoupdateChange}
                  />
                </div>
              </GridItem>
              <GridItem xs={10} sm={10} md={10} lg={10}>
                <div>
                  <CustomSelect
                    inputTitle={
                      compte.energy[energy][parameters].dso
                    }
                    selectValue={metersDso}
                    handleSelectValueChange={handleDsoChange}
                    data={dsoData}
                    disabled={!metersDsoupdate}
                  />
                </div>
              </GridItem>
            </GridContainer>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer>
              <GridItem xs={2} sm={2} md={2} lg={2}>
                <div>
                  <CustomSwitch
                    inputTitle={''}
                    checkedState={associatedcontractidupdate}
                    handleSwitchChange={handleAssociatedcontractidupdateChange}
                  />
                </div>
              </GridItem>
              <GridItem xs={10} sm={10} md={10} lg={10}>
                <div>
                  <CustomSelect
                    inputTitle={
                      compte.energy[energy][parameters].associatedcontractid
                    }
                    selectValue={associatedcontractid}
                    handleSelectValueChange={handleAssociatedcontractidChange}
                    data={utilitiesData}
                    disabled={!associatedcontractidupdate}
                  />
                </div>
              </GridItem>
            </GridContainer>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer>
              <GridItem xs={2} sm={2} md={2} lg={2}>
                <div>
                  <CustomSwitch
                    inputTitle={''}
                    checkedState={authorizationidupdate}
                    handleSwitchChange={handleAuthorizationidupdateChange}
                  />
                </div>
              </GridItem>
              <GridItem xs={10} sm={10} md={10} lg={10}>
                <div>
                  <CustomSelect
                    inputTitle={
                      compte.energy[energy][parameters].authorization
                    }
                    selectValue={authorizationid}
                    handleSelectValueChange={handleAuthorizationidChange}
                    data={authorizationData}
                    disabled={!authorizationidupdate}
                  />
                </div>
              </GridItem>
            </GridContainer>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer>
              <GridItem xs={2} sm={2} md={2} lg={2}>
                <div>
                  <CustomSwitch
                    inputTitle={''}
                    checkedState={utilityauthorizationidupdate}
                    handleSwitchChange={handleUtilityauthorizationidupdateChange}
                  />
                </div>
              </GridItem>
              <GridItem xs={10} sm={10} md={10} lg={10}>
                <div>
                  <CustomSelect
                    inputTitle={
                      compte.energy[energy][parameters].utilityauthorization
                    }
                    selectValue={utilityauthorizationid}
                    handleSelectValueChange={handleUtilityauthorizationidChange}
                    data={utilityauthorizationData}
                    disabled={!utilityauthorizationidupdate}
                  />
                </div>
              </GridItem>
            </GridContainer>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer>
              <GridItem xs={2} sm={2} md={2} lg={2}>
                <div>
                  <CustomSwitch
                    inputTitle={''}
                    checkedState={dataupdate}
                    handleSwitchChange={handleDataupdateChange}
                  />
                </div>
              </GridItem>
              <GridItem xs={10} sm={10} md={10} lg={10}>
                <div>
                  <CustomSwitch
                    inputTitle={
                      compte.energy[energy][parameters].monthlyconsumption
                    }
                    checkedState={monthlyconsumption}
                    handleSwitchChange={handleMonthlyconsumptionChange}
                    disabled={!dataupdate}
                  />
                </div>
                <div>
                  <CustomSwitch
                    inputTitle={compte.energy[energy][parameters].dailyconsumption}
                    checkedState={dailyconsumption}
                    handleSwitchChange={handleDailyconsumptionChange}
                    disabled={!dataupdate}
                  />
                </div>
                <div>
                  <CustomSwitch
                    inputTitle={compte.energy[energy][parameters].loadcurve}
                    checkedState={loadcurve}
                    handleSwitchChange={handleLoadcurveChange}
                    disabled={!dataupdate}
                  />
                </div>
                <div>
                  <CustomSwitch
                    inputTitle={compte.energy[energy][parameters].contractualdata}
                    checkedState={contractualdata}
                    handleSwitchChange={handleContractualdataChange}
                    disabled={!dataupdate}
                  />
                </div>
              </GridItem>
            </GridContainer>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <GridContainer>
              <GridItem xs={2} sm={2} md={2} lg={2}>
                <div>
                  <CustomSwitch
                    inputTitle={''}
                    checkedState={utilitydataupdate}
                    handleSwitchChange={handleUtilitydataupdateChange}
                  />
                </div>
              </GridItem>
              <GridItem xs={10} sm={10} md={10} lg={10}>
                <div>
                  <CustomSwitch
                    inputTitle={
                      compte.energy[energy][parameters].utilitydata
                    }
                    checkedState={utilitydata}
                    handleSwitchChange={handleUtilitydataChange}
                    disabled={!utilitydataupdate}
                  />
                </div>
              </GridItem>
            </GridContainer>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <Button
              disabled={buttonDisabled}
              className={
                buttonDisabled
                  ? classes.submitButtonDisabled
                  : classes.submitButton
              }
              onClick={() => {
                handleSubmit();
              }}
            >
              Editer
            </Button>
          </GridItem>
        </GridContainer>
      </form>
    </>
  );
}

export default EditMetersDialog;
